var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import SaveIcon from "@material-ui/icons/Save";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from "@mui/material/Select";
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import {MuiThemeProvider} from '@material-ui/core/styles';
import LabsDialog from '../CreateDialogue/LabsDialog';
import EditLabsDialog from '../EditDialogue/EditLabsDialog';
import {muiThemeDesign} from '../../mui-theme-design';
import {logger, customBodyForExcelReport,handleExport,permissions,muiLoaderOptions} from '../../utils';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

const ExcelJS = require('exceljs');


export default function LabsTable() {
    const [refresh, setRefresh] = React.useState(true);
    const [dataSet, setDataSet] = React.useState([]);
	const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('');
     const [isLoading, setIsLoading] = React.useState(true);
    
    React.useEffect(() => {
        if (refresh) {
            fetch('/api/lab')
                .then(res => res.json())
                .then(json => {
					setDataSet(json);
					setIsLoading(false);
				})

            setRefresh(false);
        }
            
    })
	
    const handleDialogCallback = (childData) => {
		fetch("/api/lab", {
		method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "lab": [{
                    "Name": childData.Name,
					"Location": childData.Location,
                    "IsActive": childData.IsActive
                }]
            })
        }).then(res => res.json())
        .then(json => {
            if (json.code === 'ER_DUP_ENTRY') {
                setAlertText(json.message)
                setAlert(true)
            }
        })
        logger(childData);	
        setRefresh(true)
    };

    const handleEditCallback = (childData) => {
		fetch("/api/lab", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "lab": {
                    "ID": childData.ID,
                    "Name": childData.Name,
					"Location": childData.Location,
                   "IsActive": childData.IsActive
                },
            })
        }).then(res => res.json())
        .then(json => {
            if (json.code === 'ER_DUP_ENTRY') {
                setAlertText(json.message)
                setAlert(true)
            }
        })
        logger(childData);
        setRefresh(true)
    };
    
    const handleAlertClose = () => {
        setAlert(false);
    };
	
	 
	  const columns = [];
    if (permissions.CreateLab == 1) {
       	const adminActions =  {
            name: "Admin Actions",
            options: {
                filter: false,
                sort: false,
                empty: true,
                download: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            <EditLabsDialog handleEditCallback={handleEditCallback} data={dataSet[dataIndex]} />
                        </div>
                    );
                }

            }
        };
        columns.push(adminActions);
    }
     const columns1 = [
        {
            name: "Name",
            label: "Lab Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Location",
            label: "Location",
            options: {
                filter: false,
                sort: true,
            }
        },
		{
            name: "IsActive",
            options: {
                filter: true,
                sort: true,
                empty: true,
                filterList: [1],
                customFilterListOptions:
                {
                    render: v => {
                        if (v === 0) {
                            return "Show InActive";
                        }
                        if (v === 1) {
                            return "Show Active";
                        }
                        return val;
                    },
                },
//                    { render: v => `Show ${v}` },

                    filterOptions: {
                        renderValue: val => {
                            if (val === 0) {
                                return "InActive";
                            }
                            if (val === 1) {
                                return "Active";
                            }
                            return val;
                        }
                    
                }, 
                customBodyRenderLite: (dataIndex, rowIndex) => {
                   return (
                        <div>
						    {(dataSet[dataIndex].IsActive) ? <CheckIcon /> : <DoNotDisturbIcon />}
                        </div>
                    ); 

                }
            }
		}	
    ];

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('LabrowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('LabrowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();
	
	 columns.push(...columns1);
	
	const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
        fixedHeader: true,
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		 onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			//handleExport(rows, headers);
			handleExport({rows:rows, headers:headers, filename:'Labs.xlsx', columnIndexToRemove:0})
			return false;
		},
        customToolbar: () => permissions.CreateLab===1 && !isLoading ?
         (<LabsDialog handleDialogCallback={handleDialogCallback} />):(<></>)
    };

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

	return (
        
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
            <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="labsTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft Labs
                        </Typography>
                    }
                    data={isLoading ? [] :dataSet}
                    columns={columns}
                    options={muiLoaderOptions(options, isLoading)}
                    
                />
                </Box>
            </MuiThemeProvider>
            <Dialog
                open={LockedAlert}
                onClose={handleAlertClose}
                aria-labelledby="L&P Lock"
                aria-describedby="Time Period locked for this work"
            >
                <DialogTitle id="Lab">
                    {"Duplicate Entry"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {AlertText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
        
    );
	
}